import { useLocation, useNavigate } from "react-router-dom";
import ErrorImg from "../../Assets/img/error.png";

export const ErrorPage = () => {
  const navigate = useNavigate();
  const { key: keyLocation } = useLocation();
  const isInitialLocation = keyLocation === 'default'; // <-- This value is always "default" on the initial location.
  const to = isInitialLocation ? '/' : -1;

  return (
    <section id="error" className="error-page">
      <div className="w-full h-full grid grid-cols-1 place-content-center">
        <div className="col-12 text-center">
          <img
            src={ErrorImg}
            alt=""
            className="object-cover inline mt-8 w-[30rem] phone:w-[400px]"
            height="300"
            width="400"
          />
          <h1 className="text-5xl small-phone:text-6xl font-normal mt-8">
            404 - ¡Página no encontrada!
          </h1>
          <div className="block text-2xl w-3/4 phone:w-2/4 text-font-muted mx-auto mt-8 mb-10">
            <span>
              La página que intentas acceder tal vez ha sido removida, el nombre
              ha cambiado, o está temporalmente no disponible
            </span>
          </div>
          <a
            onClick={() => navigate(to)}
            className="cursor-pointer inline w-[50%] uppercase rounded-[20rem] bg-primary text-xl rounded px-8 py-4 text-white"
          >
            Volver atrás
          </a>
        </div>
      </div>
    </section>
  );
};
